import { z } from 'zod';
export var WebsiteUserRoleAccountEnum;
(function (WebsiteUserRoleAccountEnum) {
    WebsiteUserRoleAccountEnum["EMPTY"] = "";
    WebsiteUserRoleAccountEnum["AZ_EQUITY_PROPERTIES"] = "AZ Equity Properties";
    WebsiteUserRoleAccountEnum["ACCOUNTING"] = "Accounting";
    WebsiteUserRoleAccountEnum["ADMIN"] = "Admin";
    WebsiteUserRoleAccountEnum["ASCENT_REAL_ESTATE"] = "Ascent Real Estate";
    WebsiteUserRoleAccountEnum["BARRATT_ASSET_MANAGEMENT"] = "Barratt Asset Management";
    WebsiteUserRoleAccountEnum["CMG_FINANCIAL_THE_RODRIGUEZ_HAZARD_TEAM"] = "CMG Financial - The Rodriguez Hazard Team";
    WebsiteUserRoleAccountEnum["CATALYST_GROUP_SILVERCREEK_REALTY_GROUP"] = "Catalyst Group-Silvercreek Realty Group";
    WebsiteUserRoleAccountEnum["CHARLOTTE_INVESTMENT_HOMES"] = "Charlotte Investment Homes";
    WebsiteUserRoleAccountEnum["CISNEROS_REAL_ESTATE_SOLUTIONS"] = "Cisneros Real Estate Solutions";
    WebsiteUserRoleAccountEnum["CLARK_REALTY_ASSOCIATES"] = "Clark Realty & Associates";
    WebsiteUserRoleAccountEnum["CULLEN_CREATIVE"] = "Cullen Creative";
    WebsiteUserRoleAccountEnum["DEUTSCHE_GROUP"] = "Deutsche Group";
    WebsiteUserRoleAccountEnum["EXP_REALTY"] = "EXP Realty";
    WebsiteUserRoleAccountEnum["ENTERPRISE_REALTORS"] = "Enterprise Realtors";
    WebsiteUserRoleAccountEnum["EVENTS"] = "Events";
    WebsiteUserRoleAccountEnum["EXECUTIVE_MANAGEMENT"] = "Executive Management";
    WebsiteUserRoleAccountEnum["FLEX_REALTY"] = "Flex Realty";
    WebsiteUserRoleAccountEnum["GEORGIA_RESIDENTIAL_PARTNERS"] = "Georgia Residential Partners";
    WebsiteUserRoleAccountEnum["HECHT_REAL_ESTATE_GROUP_AUSTIN"] = "Hecht Real Estate Group Austin";
    WebsiteUserRoleAccountEnum["IT"] = "IT";
    WebsiteUserRoleAccountEnum["INDY_METRO_NORTH_KELLER_WILLIAMS"] = "Indy Metro North - Keller Williams";
    WebsiteUserRoleAccountEnum["INTERN"] = "Intern";
    WebsiteUserRoleAccountEnum["INVESTMENT_FUNDS"] = "Investment Funds";
    WebsiteUserRoleAccountEnum["MR_REALTY_LLC"] = "MR Realty, LLC";
    WebsiteUserRoleAccountEnum["MAINSTAY_PROPERTY_GROUP_LLC"] = "Mainstay Property Group LLC";
    WebsiteUserRoleAccountEnum["MARKETING"] = "Marketing";
    WebsiteUserRoleAccountEnum["MCCAW_PROPERTY_MANAGEMENT"] = "McCaw Property Management";
    WebsiteUserRoleAccountEnum["MEMPHIS_CASH_FLOW"] = "Memphis Cash Flow";
    WebsiteUserRoleAccountEnum["NEU_REAL_ESTATE_GROUP"] = "Neu Real Estate Group";
    WebsiteUserRoleAccountEnum["NEW_J_MANAGEMENT_LLC"] = "New J Management LLC";
    WebsiteUserRoleAccountEnum["NEXT_HOME_PREMIER_CHOICE"] = "Next Home Premier Choice";
    WebsiteUserRoleAccountEnum["OPERATIONS"] = "Operations";
    WebsiteUserRoleAccountEnum["PAYROLL"] = "Payroll";
    WebsiteUserRoleAccountEnum["PEOPLE_OPERATIONS"] = "People Operations";
    WebsiteUserRoleAccountEnum["PRIVATE_MONEY"] = "Private Money";
    WebsiteUserRoleAccountEnum["PRIVATE_MONEY_MANAGER"] = "Private Money Manager";
    WebsiteUserRoleAccountEnum["PROPERTY_MANAGEMENT"] = "Property Management";
    WebsiteUserRoleAccountEnum["REAL_ESTATE"] = "Real Estate";
    WebsiteUserRoleAccountEnum["RESOLUTION_REALTY"] = "Resolution Realty";
    WebsiteUserRoleAccountEnum["SALES"] = "Sales";
    WebsiteUserRoleAccountEnum["SENSE_FINANCIAL_SERVICES"] = "Sense Financial Services";
    WebsiteUserRoleAccountEnum["SOFTWARE_ENGINEERING"] = "Software Engineering";
    WebsiteUserRoleAccountEnum["SOLID_SOURCE_REALTY_GA_LLC"] = "Solid Source Realty GA LLC";
    WebsiteUserRoleAccountEnum["STONES_RIVER_REALTY"] = "Stones River Realty";
    WebsiteUserRoleAccountEnum["TOP_REAL_ESTATE_PROFESSIONALS"] = "Top Real Estate Professionals";
    WebsiteUserRoleAccountEnum["VISION_REALTY_PROS_LLC"] = "Vision Realty Pros LLC";
    WebsiteUserRoleAccountEnum["WEBMASTER"] = "Webmaster";
    WebsiteUserRoleAccountEnum["WIN_WIN_REAL_ESTATE"] = "Win Win Real Estate";
    WebsiteUserRoleAccountEnum["WORLD_WIDE_REALTY"] = "World Wide Realty";
    WebsiteUserRoleAccountEnum["USER"] = "user";
})(WebsiteUserRoleAccountEnum || (WebsiteUserRoleAccountEnum = {}));
export var WebsiteUserRoleTitleEnum;
(function (WebsiteUserRoleTitleEnum) {
    WebsiteUserRoleTitleEnum["ADMIN"] = "admin";
    WebsiteUserRoleTitleEnum["EDITOR"] = "editor";
    WebsiteUserRoleTitleEnum["USER"] = "user";
    WebsiteUserRoleTitleEnum["USERCAPITAL"] = "User";
})(WebsiteUserRoleTitleEnum || (WebsiteUserRoleTitleEnum = {}));
export var WebsiteUserRoleBitMaskEnum;
(function (WebsiteUserRoleBitMaskEnum) {
    WebsiteUserRoleBitMaskEnum[WebsiteUserRoleBitMaskEnum["INCOMPLETE_REGISTRATION"] = 1] = "INCOMPLETE_REGISTRATION";
    WebsiteUserRoleBitMaskEnum[WebsiteUserRoleBitMaskEnum["USER"] = 2] = "USER";
    WebsiteUserRoleBitMaskEnum[WebsiteUserRoleBitMaskEnum["REP_VENDOR"] = 4] = "REP_VENDOR";
    WebsiteUserRoleBitMaskEnum[WebsiteUserRoleBitMaskEnum["MR_EMPLOYEE"] = 8] = "MR_EMPLOYEE";
})(WebsiteUserRoleBitMaskEnum || (WebsiteUserRoleBitMaskEnum = {}));
export var UserBookmarkStatusEnum;
(function (UserBookmarkStatusEnum) {
    UserBookmarkStatusEnum["STAR"] = "star";
    UserBookmarkStatusEnum["HIDE"] = "hide";
})(UserBookmarkStatusEnum || (UserBookmarkStatusEnum = {}));
export const websiteUserRoleSchema = z.object({
    bitMask: z.enum(WebsiteUserRoleBitMaskEnum).optional(),
    title: z.enum(WebsiteUserRoleTitleEnum).optional(),
    account: z.enum(WebsiteUserRoleAccountEnum).optional(),
});
